import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import supabase from "../../services/supabaseClient";
import { getCurrentProfile, getCurrentUser } from "../../services/authService";

export default function AuthGuard({ role, children }) {
  const location = useLocation();
  const [state, setState] = useState({
    loading: true,
    user: null,
    profile: null,
  });

  useEffect(() => {
    let mounted = true;
    async function loadSession() {
      const { user } = await getCurrentUser();
      if (!user) {
        if (mounted) setState({ loading: false, user: null, profile: null });
        return;
      }
      const profileResult = await getCurrentProfile(user.id);
      if (mounted) {
        setState({
          loading: false,
          user,
          profile: profileResult.data || { role: user.role || "customer" },
        });
      }
    }
    loadSession();
    const { data: listener } = supabase?.auth.onAuthStateChange(() =>
      loadSession(),
    ) || { data: { subscription: { unsubscribe() {} } } };
    return () => {
      mounted = false;
      listener.subscription.unsubscribe();
    };
  }, []);

  if (state.loading)
    return <div className="auth-loading">Checking your session...</div>;
  if (!state.user)
    return (
      <Navigate
        to={role === "admin" ? "/admin/login" : "/customer/login"}
        replace
        state={{ from: location.pathname }}
      />
    );
  const userEmail = String(state.user?.email || "").toLowerCase();
  const profileRole = String(state.profile?.role || "").toLowerCase();
  const profileUsername = String(state.profile?.username || "").toLowerCase();

  const hasAdminAccess =
    ["admin", "superadmin"].includes(profileRole) ||
    ["inspirationsoftsolutions@gmail.com", "trishultoursandtravels2315@gmail.com"].includes(userEmail) ||
    ["trishuladmin", "inspiration"].includes(profileUsername);

  if (role === "admin" && !hasAdminAccess)
    return <Navigate to="/customer/dashboard" replace />;
  if (role === "customer" && hasAdminAccess)
    return <Navigate to="/admin/dashboard" replace />;
  return children;
}
